// Chakra imports
import {
  Flex,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { SidebarContext } from 'contexts/SidebarContext';

export default function AuthNavbar(props) {
  const { logo, logotext, secondary, sidebarWidth, ...rest } = props;

  let navbarBg = 'none';
  let navbarShadow = 'initial';
  let navbarPosition = 'absolute';

  return (
    <SidebarContext.Provider value={{ sidebarWidth }}>
      <Flex
        position={navbarPosition}
        top='16px'
        left='50%'
        transform='translate(-50%, 0px)'
        background={navbarBg}
        boxShadow={navbarShadow}
        borderRadius='15px'
        px='16px'
        py='22px'
        mx='auto'
        width='1044px'
        maxW='90%'
        alignItems='center'
        zIndex='3'
      >
        <Flex w='100%' justifyContent={{ sm: 'start', lg: 'space-between' }}>
        </Flex>
      </Flex>
    </SidebarContext.Provider>
  );
}

AuthNavbar.propTypes = {
  color: PropTypes.oneOf(['primary', 'info', 'success', 'warning', 'danger']),
  brandText: PropTypes.string,
};
